import NoData from 'components/noData/noData'
import { useProductsReleases } from 'hooks/use-products'
import React from 'react'
import { useParams } from 'react-router-dom'
import ReleasesCard from '../component/releasesCard'

const Releases = () => {
  const {id}  = useParams()
  const {productsReleases,isError,isSuccess,isLoading}=useProductsReleases(id)
  
  return (
    <div className='page-releases'>
      <div className='row'>
        {
          isSuccess && productsReleases?.map(rel=>(
            <div className='col-xl-4 col-lg-6' key={rel.id}>
            <ReleasesCard className={`${rel?.isCurrent ? 'current' : 'past' && rel?.isLatest ? 'latest' : 'past'}` } item={rel} />
          </div>
          ))
        }
          {
            productsReleases.length <= 0 && (
                <div className="col-12">
                <NoData  />
              </div>
            )
        }
      </div>
    </div>
  )
}

export default Releases